import {React , useState} from 'react';
import InfoBulle from './inforesult';

const parseStringMontant = function (text) {
	var result = '';
    var pattern = /[0-9,\.]+(€|%)/ig;
    var match = text.match(pattern);
    var textsplit;
    while (match != null) {
      textsplit = text.split(match[0]);

      result = result + text.replace(match[0], '<strong>' + match[0] + '</strong>');
      result = result.replace(textsplit[1], '');

      text = textsplit[1];
      match = text.match(pattern);
    }
    result = result + text;
    return <span dangerouslySetInnerHTML={{__html: result}} ></span>;
}

const DroitCell = function(props){
	const droit = props.model;
	const [detail  , setDetail] = useState(false);

	const switchDetail = (e)=>(setDetail(!detail));

	var definition_period;
	var image =  !(props.localImg) ? droit.imgSrc : '/wp-content/build-velo/logos/' + droit.imgSrc ;
	
	if (droit.value !== true ) { 
		var montant = !droit.floorAt ? droit.value : droit.value - (droit.value % droit.floorAt) ;
	}else {
		var montant = droit.value;
	}

	var unit = !droit.unit && typeof droit.value === 'number' ? '€' : droit.unit;
 	var suffix = droit.suffix ;

 	if (droit.definition_period && unit === '€') {
 		if( droit.definition_period.match(/\d{4}-\d{2}/i) !== null){
 			definition_period = ' / mois';

 		} else if (droit.definition_period.match(/\d{4}/) !== null){
 			definition_period = ' / an';
 	
 		}

 		if (  ["bourse_college", "bourse_lycee" ,"cheque_energie"].includes(droit.nom) ) {
 			definition_period = ' / an';

 		}
 	}

 	var type = droit.type;

 	if (droit.nom === "garantie_jeunes") {
 		montant = true;
 		unit = '';
 		definition_period='';
 		type = 'boolean';
 	} else if (droit.nom === 'livret_epargne_populaire_taux'){
 		montant = 2.7;
 		suffix = '';
 	}

 	if (unit === '%' ||  unit === '€' || typeof(montant) !== 'string'){
 		montant = <strong>{montant}</strong>;
 		unit = <strong>{unit}</strong>;
 	} else {
 		montant = typeof montant === 'string' ?  parseStringMontant(montant) : montant;
 	}
 	
 	if ( type === "boolean") {
 		suffix = '';
 		unit = '';
 		definition_period = '';
 	}

	return <>
		<div className= {"droit "+props.categorie}>
				<div className="cell-left">
					<img className="droit-img"
						src={image}
						alt=""
					/>
					
					{typeof droit.indication !== 'undefined' && droit.indication !== "" ?
							<span>{droit.label} <InfoBulle message={droit.indication}/></span>
					  :<span>{droit.label}</span>
					}
				</div>
				
				<div className="cell-right">
					<div className="button-container">
						<a href={droit.link} target="_blank" rel="noreferrer">
							<button className="btn-obtenir">Comment l'obtenir ?</button>
						</a>

						{(droit.link2 !== "#link" ) ? 
							<a href={droit.link2} target="_blank" rel="noreferrer" className="link2">
								<button className="btn-obtenir">En savoir plus ?</button>
							</a>
						: ''
						}
					</div>
					{ !( type === 'number' && droit.value <= 0 ) ?

						<span> {montant} {unit}  {definition_period} {suffix}</span>
						:''
					}

					{ (type === 'boolean' || (type ==='number' && droit.value === 0)) ? 
						<span className="check"><i className="fa fa-check-circle"></i></span> :''
					}
					<span className="mobile-only btn-show" onClick={switchDetail}>
						<i className={ detail ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
					</span>
				</div>
			</div>
			{  ( detail ) ? 
				<div className="droit-details fade-in">
					<p>{droit.indication}</p>
					<a href={droit.link} target="_blank" rel="noreferrer">
					<button className="btn-obtenir mobile-only">Comment l'obtenir ?</button>
					</a>
					{(droit.link2 !== "#link" ) ? 
							<a href={droit.link2} target="_blank" rel="noreferrer" className="link2">
								<button className="btn-obtenir">En savoir plus ?</button>
							</a>
						: ''
						}
				</div>
			: ''

			}
		</>;
}

export {DroitCell};
